import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import { IconAudioOnly, IconAudioOnlyOff } from 'jitsi/base/icons/svg';
import AbstractButton from 'jitsi/base/toolbox/components/AbstractButton';
import { toggleAudioOnly } from 'jitsi/base/audio-only/actions';
/**
 * Implementation of a button for accessing audio only mode.
 */
class AudioOnly extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.audioOnly';
        this.icon = IconAudioOnly;
        this.label = 'toolbar.audioOnlyOn';
        this.toggledIcon = IconAudioOnlyOff;
        this.toggledAccessibilityLabel = 'toolbar.audioOnlyOff';
        this.tooltip = 'toolbar.accessibilityLabel.audioOnly';
        this.toggledLabel = 'toolbar.audioOnlyOff';
        this.toggledTooltip = 'toolbar.audioOnlyOff';
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props.toggledAudioOnly;
    }
    /**
     * Handles clicking the button, and toggles the audio only mode.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(toggleAudioOnly());
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        toggledAudioOnly: state['features/base/audio-only'].enabled
    };
};
export default translate(connect(mapStateToProps)(AudioOnly));
